import { Box, Skeleton, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';

export function SignalsHeaderMetricsSkeleton() {
  return (
    <Grid container spacing={2} mb={3}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
          <Box
            sx={{
              background: '#fff',
              border: '1px solid #E5E7EB',
              borderRadius: '12px',
              p: '16px',
              borderLeft: '3px solid #E5E7EB',
              height: '100%'
            }}
          >
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
              <Skeleton variant='text' width='42%' height={20} />
              <Skeleton variant='circular' width={32} height={32} />
            </Stack>
            <Skeleton variant='text' width='38%' height={44} sx={{ mt: 1 }} />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export function SignalsListingSkeleton() {
  return (
    <Box
      sx={{
        border: '1px solid #E5E7EB',
        borderRadius: '12px',
        overflow: 'hidden',
        background: '#fff'
      }}
    >
      <Box sx={{ p: 2, borderBottom: '1px solid #E5E7EB', bgcolor: '#F9FAFB' }}>
        <Stack direction='row' spacing={2}>
          <Skeleton variant='text' width='20%' height={24} />
          <Skeleton variant='text' width='28%' height={24} />
          <Skeleton variant='text' width='16%' height={24} />
          <Skeleton variant='text' width='24%' height={24} />
        </Stack>
      </Box>
      <Stack sx={{ p: 2 }} spacing={1.5}>
        {Array.from({ length: 8 }).map((_, index) => (
          <Skeleton key={index} variant='rounded' height={42} />
        ))}
      </Stack>
      <Stack direction='row' justifyContent='flex-end' spacing={1} sx={{ px: 2, pb: 2 }}>
        <Skeleton variant='rounded' width={36} height={32} />
        <Skeleton variant='rounded' width={36} height={32} />
        <Skeleton variant='rounded' width={36} height={32} />
      </Stack>
    </Box>
  );
}

function BreakdownCardSkeleton() {
  return (
    <Grid size={{ xs: 12, md: 6, lg: 3 }}>
      <Box border='1px solid #ECECEC' bgcolor='#FAFAFA' borderRadius={2} p={2}>
        <Skeleton variant='text' width='46%' height={20} sx={{ mb: 1 }} />
        <Stack gap={1.5}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Box key={index}>
              <Stack direction='row' justifyContent='space-between' alignItems='center' mb={0.5}>
                <Skeleton variant='text' width='36%' height={22} />
                <Skeleton variant='text' width='30%' height={20} />
              </Stack>
              <Skeleton variant='rounded' height={4} />
            </Box>
          ))}
        </Stack>
      </Box>
    </Grid>
  );
}

export function SignalsInsightsBreakdownSkeleton() {
  return (
    <Grid container spacing={2}>
      {Array.from({ length: 4 }).map((_, index) => (
        <BreakdownCardSkeleton key={index} />
      ))}
    </Grid>
  );
}

export function SignalsInsightsChartSkeleton() {
  return (
    <Stack spacing={1.2}>
      {Array.from({ length: 8 }).map((_, index) => (
        <Stack key={index} direction='row' spacing={1.2} alignItems='center'>
          <Skeleton variant='text' width={110} height={18} />
          <Skeleton variant='rounded' width={`${78 - index * 6}%`} height={28} />
        </Stack>
      ))}
    </Stack>
  );
}

export function KeywordSystemTagsSkeleton() {
  return (
    <Box display='flex' flexWrap='wrap' gap={1} alignItems='center'>
      {Array.from({ length: 10 }).map((_, index) => (
        <Skeleton key={index} variant='rounded' width={92 + (index % 3) * 18} height={30} sx={{ borderRadius: 48 }} />
      ))}
    </Box>
  );
}
